total_form_recipients = 0
temp = 100
count = 100
custom_category_count = -1
fileObject = {}

$(document).ready ->
  disclaimer_questions = [14, 15, 46]
  hr_main_form_div = $('#hr_main_form_div')
  
  if $('#pda_modal').length > 0
    $('#pda_modal').openModal({dismissible: false})

  $(".cancel-dpa-modal").on "click", (event) ->
    $('#pda_modal').closeModal()

  $(".close-dpa-modal").on "click", (event) ->
    $('#pda_modal').closeModal()

  $(".checkbox-select-all").on "change", (event) ->
    if $(this).get(0).checked
      $(this).parents('.lso-checkbox').find('input[type=checkbox]').prop('checked', true)
      disclaimer_questions.forEach (q) ->
        $("#questions_#{q}").prop('checked', false)
    else
      $(this).parents('.lso-checkbox').find('input[type=checkbox]').prop('checked', false)

  $(".checkbox-questions").on "change", (event) ->
    $(this).parents('.lso-checkbox').find('.checkbox-select-all').prop('checked', false)

  $(".checkbox-select-all-forms").on "change", (event) ->
    if $(this).get(0).checked
      $(this).parents('table').find('tbody input[type=checkbox]').prop('checked', true)
    else
      $(this).parents('table').find('tbody input[type=checkbox]').prop('checked', false)

  $(".checkbox-forms").on "change", (event) ->
    $(this).parents('table').find('.checkbox-select-all-forms').prop('checked', false)

  $(".template-questions").on "click", (e) ->
    if disclaimer_questions.indexOf(parseInt($(this).prev().val())) > -1 && !$(this).prev().prop('checked')
      unless confirm('Please check local laws and regulations to ensure that asking this question to your new hires is legally allowed')
        $(this).prev().prop('checked', false)
        e.preventDefault()

  dragable_calls()
  remove_question_container()
  add_answer_options(false)

  hr_main_form_div.on "drop", ".category-container", (event, ui) ->
    $(this).find('.empty-category').hide(200)
    draggableId = ui.draggable
    question = ''
    description = ''
    original_question_id = null
    answer_options = false
    if draggableId.hasClass('question-container')
      draggableId.css("display", "none")
      dup = $($(this).find('#existing-question-container').get(0)).clone()
      question = $($(ui.draggable).find('.question')[0]).text()
      description = $($(ui.draggable).find('.description')[0]).text()
      original_question_id = $(ui.draggable).data('question-id')
      $(dup).data('question-id', original_question_id)
    else
      dup = $($(this).find('#new-question-container').get(0)).clone()
      answer_options = $(ui.draggable).data('answer-options')
    $(dup).addClass('removable-question-container')
    icon = icon_from_id($(ui.draggable).data("icon-id"))
    $($(dup).find('.question')[0]).val(question)
    if answer_options
      $(dup).find('.answer-option-input').show()
      $(dup).find('.description').hide()
    else
      $(dup).find('.answer-option-input').hide()
      $($(dup).find('.description')[0]).val(description)
    $($(dup).find('.icon')[0]).val($(ui.draggable).data("icon-id"))
    $($(dup).find('.original-question-id')[0]).val(original_question_id)
    $($(dup).find('.question-icon')[0]).addClass(icon)
    id = $(dup).find('.checkbox-custom').attr('id')
    className = $(dup).find('.checkbox-custom-label').attr('for')
    $(dup).find('.checkbox-custom').attr('id', id + "-#{count}")
    $(dup).find('.checkbox-custom-label').attr('for', className + "-#{count}")
    count++
    dup.css("display", "block")
    $(this).append(dup)

    remove_question_container()
    add_answer_options(true)

  hr_main_form_div.on "hover", ".new-category", (e) ->
    if $('.new-category-title').html().indexOf('class="fa fa-plus"') == -1
      $('.new-category-buttons').css('opacity', 1)
    else
      $('.new-category-buttons').css('opacity', 0)

  hr_main_form_div.on "click", ".new-category-title", (e) ->
    this_parent_div = $(this).parents('.category-title')
    this_parent_div.find('.new-category-title').hide()
    if $(this).parent().next().find('.removable-question-container').length == 0
      $(this).parent().next().find('.empty-category').show()
    this_parent_div.find('.new-category-input').show()
    this_parent_div.find('.new-category-container').show()

  hr_main_form_div.on "click", ".new-category-buttons .fa.fa-trash", (e) ->
    this_parent_div = $(this).parents('.custom_question_categories_main_div')
    if confirm('Do you really want to remove this category? All the questions will also be removed.')
      this_parent_div.remove()

  hr_main_form_div.on "click", ".save-new-category", (e) ->
    this_parent = $(this).parents('.category-title')
    this_parent.find('.new-category-title').show()
    custom_cat_title = this_parent.find('.new-category-title-input').val()
    if !!custom_cat_title
      this_parent.find('.new-category-title').text(custom_cat_title)
    else
      this_parent.find('.new-category-title').html("<i class='fa fa-plus'></i>Category")
    this_parent.find('.new-category-input').hide()

  $(".templates form").on "keypress", (e) ->
    if $(e.target).attr('id') != 'template_recipients' && e.keyCode == 13
      return false;

  $("#hr_form_language").on "change", (event) ->
    l_id = $(this).val()
    $('#switched_to').val(l_id)
    $(this).parents('form').submit()

  hr_main_form_div.on "click", ".hr_main_form_btn", (event) ->
    event.preventDefault();
    input = document.getElementsByClassName('new-category-title-input');
    array_val = ['personalinformation', 'jobinformation', 'emergencycontactinformation']
    i=0
    while i< input.length
      array_val.push(input[i].value.trim().replace(/\s/g, '').toLowerCase())
      i++
    duplicate = find_duplicate_in_array(array_val)
    if duplicate
      alert("Categories name must be unique")
      enablePageSubmit("Save")
    else if $("#template_name").val().trim() == ''
      alert("Form title is missing, Please enter form title")
    else
      $(this).parents('form').submit()

  hr_main_form_div.on "click", ".upload-explanation-image", (event) ->
    $(this).parent().find('.explanation-image-file').click()

  hr_main_form_div.on "change", ".explanation-image-file", (event) ->
    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype = file.type;
    fileObject.filename = file.name;
    $(this).parent().find('.image-title').text(file.name)
    image_file = $(this)
    $(image_file).parent().find('.filename').val(file.name)
    $(image_file).parent().find('.filetype').val(file.type)

    reader = new FileReader()
    reader.onload = (e) ->
      fileObject.content = e.target.result
      $(image_file).parent().find('.explanation-image').show()
      $(image_file).parent().find('.explanation-image').attr('src', e.target.result)
      $(image_file).parent().find('.upload-explanation-image').hide()
      $(image_file).parent().find('.content').val(e.target.result.replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, ""))
      return

    reader.readAsDataURL file
    return

  hr_main_form_div.on "click", ".delete-button", (event) ->
    $(this).parent().find('.explanation-image').hide()
    $(this).parent().find('.explanation-image').attr('src', '')
    $(this).parent().find('.upload-explanation-image').show()
    $(this).parent().parent().find('.explanation').find('textarea').val('')
    $(this).parent().find('.image-title').text('Upload an image')
    $(this).parent().find('.filename').val('null')
    $(this).parent().find('.filetype').val('null')
    $(this).parent().find('.content').val('null')

  hr_main_form_div.on "click", ".save-dependency-button", (event) ->
    $(this).parents('form').find('#adding_dependency').val(true)
    $(this).parents('form').submit()

  hr_main_form_div.on "click", ".exp_button", (event) ->
    $(this).parents('form').submit()

  hr_main_form_div.on "click", ".add_custom_cat_button", (event) ->
    $.ajax(
      type: 'GET',
      url:$(this).data('url'),
      contentType: 'text/javascript',
      data:
        'cat_id': custom_category_count
    ).done((data, textStatus, jqXHR) ->
      custom_category_count--
      $('.custom-questions-container').append(data)
      dragable_calls()
      remove_question_container()
      add_answer_options(false)
      collapseAll()
      $('html, .custom-questions-container').animate({
          scrollTop: $(".custom_question_block").offset().top},
        'slow');
      
      
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      return
    )
    false

  hr_main_form_div.on "click", ".remote_modal_laod", (event) ->
    event.preventDefault()
    $.ajax(
      type: 'GET',
      url:$(this).data("url"),
      contentType: 'text/javascript'
    ).done((data, textStatus, jqXHR) ->
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      return
    )
    false

dragable_calls = () ->
  $('.question-container').draggable({revert: true})
  $('.question-type-container').draggable({revert: true})
  $('.category-container').droppable(accept: ".question-container, .question-type-container")
  $('.category-container').sortable()
  $('.custom-questions-container').sortable()

remove_question_container = () ->
  $('.remove-question').off "click"
  $('.remove-question').on "click", () ->
    parent_container = $(this).parents('.category-container')
    if $(this).parents('.existing-question-container').length > 0
      question_id = $(this).parents('.existing-question-container').data('question-id')
      $(this).parents('.existing-question-container').next('.connected-question').remove()
      $(this).parents('.existing-question-container').siblings('.connecting-child-container').remove()
      $(this).parents('.existing-question-container').remove()
      $(".question-#{question_id}").show(200)
    else
      $(this).parents('.new-question-container').next('.connected-question').remove()
      $(this).parents('.new-question-container').siblings('.connecting-child-container').remove()
      $(this).parents('.new-question-container').remove()
    if $(parent_container).find('.new-question-container').length == 1 && $(parent_container).find('.existing-question-container').length == 1
      $(parent_container).find('.empty-category').show(200)

icon_from_id = (id) ->
  switch id
    when 1
      'fa-bars'
    when 2
      'fa-calendar'
    when 3
      'fa-hashtag'
    when 4
      'fa-picture-o'
    when 5
      'fa-caret-square-o-down'
    when 6
      'fa-check-circle-o'
    when 7
      'fa-credit-card'
    when 8
      'fa-phone'
    when 9
      'fa-envelope'
    when 10
      'fa-cloud-upload'
    when 11
      'fa-dot-circle-o'
    when 12
      'fa-globe'
    else
      'fa-question'

window.add_answer_options = (new_question) ->
  $('.answer-option-input').off "keyup"
  $('.answer-option-input').on "keyup", ->
    all_options = ''
    dup = $(this).clone()
    $(dup).val('')
    container = $(this).parent()
    delay (->
      append_option = true
      $(container).find('.answer-option-input').each (index) ->
        if $(this).val() == ''
          append_option = false
        else
        all_options += $(this).val()
        all_options += ',' if index != ($(container).find('.answer-option-input').length - 1)
      $(container).find('.answer-option').val(all_options)
      if append_option && new_question
        $(container).append(dup)
        add_answer_options(new_question)
      return
    ), 1000

delay = do ->
  timer = 0
  (callback, ms) ->
    clearTimeout timer
    timer = setTimeout(callback, ms)
    return

window.add_form_recipient_fields = (link, association, fields_to_clone, view) ->
  if (view == 'new')
    total_form_recipients++
  else
    temp++;
    total_form_recipients = temp;

  regexp = new RegExp('new_' + association, 'g')
  $(link).parent().parent().children('.recipients-list').append fields_to_clone.replace(regexp, total_form_recipients)
  return

window.remove_form_recipient_fields = (link) ->
  $(link).siblings().val 1
  $(link).parent().parent().remove()
  return
